<template>
    <div class="welcome" @click.self="doHide" v-if="welcomeShow">
        <div style="width:60%;height: auto;min-width:360px;position:relative;">
            <img src="../assets/img/Welcome.png" style="width:100%;height:auto;background: #fff;" />
            <a @click="doHide" >
                <Icon type="ios-close-circle-outline" style="position:absolute;right:0;top:0;color:#f66;font-size:30px;"/>
            </a>
       </div>
    </div>
</template>

<script>
export default {
    components: {},
    data: function() {
        return {
            welcomeShow:true,
        };
    },
    methods: {
        doHide: function() {
            this.welcomeShow = false;
        },
        created: function() {
            console.log('[welcome]');
        }
    }
};
</script>

<style scoped>
.welcome {
    position: fixed;
    top:0;
    left:0;
    width:100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0,0,0,0.7);
    transition: ease all 0.3s;
    z-index:1000;
}
.welcome::before{
    width:100%;
    height: 100%;
    position:absolute;
    -webkit-filter: blur(10px);
    filter:blur(10px);
}
</style>
